import { Rocket } from "lucide-react";
import { useUIStore } from "@/stores/ui.store";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function HelpFloatingButton() {
  const { setOnboardingOpen, onboardingOpen } = useUIStore();
  const { t } = useTranslation();

  // If the modal is open, we can choose to hide the button or keep it
  if (onboardingOpen) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => {
              setOnboardingOpen(true);
            }}
            className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-primary/30"
            aria-label={t("onboarding.floatingHelp")}
          >
            <Rocket className="h-6 w-6 animate-pulse" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="mr-2 font-medium">
          <p>{t("onboarding.floatingHelp")}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
